module.exports = "<app-backendsettings [is_dashboard]=true>\r\n</app-backendsettings>"